import React, { useEffect, useState } from 'react'
import fetch from '../../uitls/fetch'
import BannerItem, { BannerStyleTypes } from './BannerItem'

interface BannerResultProp {
  id: number
  title: string
  label_names: BannerStyleTypes[]
  body: string
}

interface BannerDataProps {
  count: number
  articles: BannerResultProp[]
}

export const parseBannerStyle = (styles: string[]): BannerStyleTypes => {
  const possibleLabels = ['alert_info', 'alert_danger', 'alert_warning', 'alert_success']

  // order of labels in payload is alphabetical, we dont know if label will be on first or second place.
  // filter the array and extract correct label based on possibleLabels
  const correctStyleExtracted = styles.filter((style: string): BannerStyleTypes => {
    return possibleLabels.includes(style) as unknown as BannerStyleTypes
  })[0]

  // provide fallback for wrong data regarding banner style
  const fallbackStyle = 'alert_info' as BannerStyleTypes
  return (correctStyleExtracted as BannerStyleTypes) || fallbackStyle
}

export const replaceHrefWithSubscription = (htmlString: string): string => {
  if (!htmlString) return '';
  
  // Regular expression to match <a> tags with their attributes
  const linkRegex = /(<a\s[^>]*?href=["'])([^"']*)(["'][^>]*?>)/gi;
  const replacedHtml = htmlString.replace(linkRegex, (match, before, href, after) => {
    return `${before}/subscription${after}`;
  });
  
  return replacedHtml;
};

const NotificationBanner = () => {
  const [bannerData, setBannerData] = useState<BannerDataProps>({
    count: 0,
    articles: [],
  })

  useEffect(() => {
    let isMounted = true
    const fetchData = async () => {
      try {
        // Step 1: Fetch user info
        const userRes = await fetch('/bff/user/me')
        const userJson = await userRes.json()
  
        // If is test_user, do not proceed
        if (userJson?.user_info?.test_user === 1) {
          return 
        }
  
        // fetch notifications
        const bannerRes = await fetch('/php/advanced_ajax_handler.php?type=zendesk_notifications')
        const jsonBody = await bannerRes.json()

        // EVR-12037: TODO remove this code once the banner is offline
        if (jsonBody.length > 0 && jsonBody[0].response) {
          const originalResponse = jsonBody[0].response
          const newBody = replaceHrefWithSubscription(originalResponse.articles[0].body)
          const updatedArticles = {...originalResponse.articles[0], body: newBody}
          
          if (isMounted) setBannerData({...originalResponse, articles: [updatedArticles]})
        }
      } catch (err) {
        console.log("Could not fetch banner data ", err)
      } 
    }

    fetchData()
    return () => { isMounted = false }
  }, [])

  if (bannerData.count === 0) {
    return null
  }

  return (
    <>
      {bannerData && bannerData.articles
        ? bannerData.articles.map((bannerItem: BannerResultProp) => (
            <BannerItem
              key={bannerItem.id}
              bannerStyle={parseBannerStyle(bannerItem.label_names)}
              title={bannerItem.title}
              message={bannerItem.body}
            />
          ))
        : null}
    </>
  )
}

// Use React.memo to prevent unnecessary re-renders
export default React.memo(NotificationBanner)
